const onlineClassEn = {
    schedule: require('../../lang/en/online_class/Schedule').default,
};

export default onlineClassEn;
